import { atomWithSessionStorage } from '@capsicum/common';

type PartnerWebAppAtom = {
	hasCheckedBeenDone: boolean;
	partnerWebAppId: null | string;
};

export const partnerWebAppAtom = atomWithSessionStorage<PartnerWebAppAtom>('partnerWebApp', {
	hasCheckedBeenDone: false,
	partnerWebAppId: null
});
